import type { MasterState } from './masterState.ts';

export type SetMasterState = (updater: (state: MasterState) => MasterState) => void;

export const makeRefreshDialogState = (
	setMasterState: SetMasterState,
	refetchQueries: () => Promise<any>,
	additionalStateUpdates?: Partial<MasterState>,
) => {
	return async () => {
		try {
			await refetchQueries();
			setMasterState((s: MasterState) => ({
				...s,
				isSaving: false,
				sessionState: 'shareAndRestrict',
				...additionalStateUpdates,
			}));
		} catch (error) {
			void error;
			//TODO add experience handling here https://product-fabric.atlassian.net/browse/CCPERMS-4897
		}
	};
};
